import {
  Dashboard,
  ListAltRounded,
} from "@mui/icons-material";
import { DASHBOARD_ROUTE, EXAM_ROUTE } from "app/constants/route";

export const useMenuList = ()=> {

  return {
    menus:[
      {
        onClick: () => {
        },
        href: DASHBOARD_ROUTE,
        text: "Dashboard",
        icon: <Dashboard />,
      },
      {
        onClick: () => {
        },
        href: EXAM_ROUTE,
        text: "Exam",
        icon: <ListAltRounded />,
      },
      // {
      //   onClick: () => {
      //     logEvent(analytics, "click_sidebar_profile");
      //   },
      //   href: "/profile",
      //   text: "My Profile",
      //   icon: <GroupRounded />,
      // },
    ]
  }
}